import { getUnlocalizedPath } from '@src/i18n/locale.util'

import type { NavItemVisibility } from './TopNavV6Props'

/**
 * Determines if a nav item should be marked as active based on the current pathname.
 */
export function isActiveNavItem(href: string, pathname: string): boolean {
  try {
    // Skip external URLs - they should never be active
    if (href.startsWith('http://') || href.startsWith('https://')) {
      const linkUrl = new URL(href)
      if (linkUrl.origin !== window.location.origin) return false
    }

    const linkUrl = new URL(href, window.location.origin)
    const currentPath = getUnlocalizedPath(pathname)
    const navPath = linkUrl.pathname

    // Exact match
    if (navPath === currentPath) return true

    // Parent route match
    if (navPath !== '/' && currentPath.startsWith(navPath + '/')) return true

    return false
  } catch (error) {
    return false
  }
}

/**
 * Determines if a nav item should be visible based on the user's state.
 */
export function isNavItemVisible(
  visibility: NavItemVisibility | undefined,
  user: { hasBodiAccess?: boolean } | null
): boolean {
  const isLoggedIn = Boolean(user)
  const hasBodiAccess = Boolean(user?.hasBodiAccess)

  switch (visibility) {
    case 'loggedIn':
      return isLoggedIn
    case 'loggedOut':
      return !isLoggedIn
    case 'bodiMember':
      return isLoggedIn && hasBodiAccess
    case 'nonBodiMember':
      return !hasBodiAccess
    case 'always':
    default:
      return true
  }
}
